import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { error } from 'console';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-teams-c',
  templateUrl: './teams-c.component.html',
  styleUrls: ['./teams-c.component.css']
})
export class TeamsCComponent implements OnInit {
  teamList: any;
  empList: any;
  userData: any;
  clientId: any;
  mangerList: any;
  pageOption = 7;
  pageOptionModal = 7;
  page: number = 1;
  pageOption1 = 7;
  pageOptionModal1 = 7;
  page1: number = 1;
  form: FormGroup;
  pageUnassigned: number = 1; // Initialize to page 1
pageAssigned: number = 1;
  manager:any;
  unassignedEmpList: any[] = []; // Populate this with unassigned employee data
  assignedEmpList: any[] = []; // Populate this with assigned employee data
  selectedEmpIndices: boolean[] = [];
  selectedAssignedEmpIndices: boolean[] = [];
  teamName: any;
  teamId: any = 0;
  movedEmpIds: any[] = [];
  managerId: Promise<void>;
  constructor(private commonService:CommonService) { }
  isCreatTeamOpenPopUp:boolean=false;

  ngOnInit(): void {
    this.form = new FormGroup({
      searchValue: new FormControl(''),
      assignSearchValue:new FormControl(''),
    });
    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userData = JSON.parse(userDataObj);
        if(this.userData.attributes.role === 'clients'){
          this.clientId=this.userData.email;
        }
      } catch (error) {

      }
    }
    this.commonService.pageLoadInModal.subscribe((result: string) => { 
      if (result == "createTeam") {
        this.isCreatTeamOpenPopUp = true;
        this.commonService.commonModel.next(true); 
      }
    });
    this.commonService.commonModelReset.subscribe((result) => {
      this.resetModalVariable();
    })
    this.getTeamList();
    this.getAllManagerAndEmp();
  }
  createTeamEvent(requiredSecondTime = false) {
    this.commonService.pageLoadInModal.next("createTeam");  
    setTimeout(() => {
      if (requiredSecondTime) {
        this.commonService.pageLoadInModal.next("createTeam"); 
      } 
    }, 100);
    
  }
  resetModalVariable(){
    this.isCreatTeamOpenPopUp = false;
  }
  getTeamList(){
    this.commonService.getRequestWithToken(`clientteam/search/${this.clientId}`,[]).then(
        (resp) => {
         console.log('teams list=>',resp);
         this.teamList=resp;
         this.teamList=this.teamList.data;
         console.log(this.teamList)
        },
        (error) => {
          console.error('Error:', error);
         
        }
      );
     }   
 getAllManagerAndEmp() {
      this.commonService.getRequestWithToken(`users/clientid/${this.clientId}?role=Employee`, []).then((resp: any) => {
           this.mangerList = resp.data;
           this.empList=resp.data;
           console.log(this.mangerList);
           this.mangerList = this.mangerList.filter(customer=>!customer.administrator && customer.userLimit === 0); 
           if(this.mangerList.isDealer) {
             const allowedRoles = 'manager'
             this.mangerList = this.mangerList.filter(customer => {
               const role = customer.attributes?.role;
               return role && allowedRoles.includes(role.toLowerCase());
           })
           this.empList = this.mangerList.filter(customer=> customer?.role == 'Employee');  
           this.unassignedEmpList = this.mangerList.filter(customer=> customer?.role == 'Employee'); 
         
           }else  {
             const allowedRoles = 'manager'
             this.empList = this.empList.filter(customer => {
            const role = customer.attributes?.role;
              return role && allowedRoles.includes(role.toLowerCase());
   });
        this.empList = this.mangerList.filter(customer=> customer?.role == 'Employee'); 
        this.unassignedEmpList = this.mangerList.filter(customer=> customer?.role == 'Employee'); 
          
         }
       });

       
  
     }
getTeamDetails(event:any){
  debugger
  const selectedTeam = this.teamList[event - 1];
  if (selectedTeam){
    this.teamId=selectedTeam?.id;
    this.teamName=selectedTeam?.teamName;

    console.log(selectedTeam);
    this.commonService.getRequestWithToken(`clientteam/search/Suzuki123?teamName=${this.teamName}`,[]).then(
      (resp:any)=>{
debugger
        this.managerId=resp.data[0].manager;
        console.log(this.managerId);
      this.commonService.getRequestWithToken(`users/clientid/${this.clientId}?role=Employee&team=${this.teamId}`, []).then((resp: any) => {
    this.mangerList = resp.data.filter(customer=>!customer.administrator && customer.userLimit === 0); 
     this.assignedEmpList =resp.data.filter(customer=> customer?.role == 'Employee'); 
     this.commonService.getRequestWithToken(`users/clientid/${this.clientId}?role=manager`, []).then(
      (resp:any)=>{
        console.log('manager list',resp)
        this.manager=resp.data.filter(manager => manager.id === this.managerId);
        console.log('manager',this.manager[0].name);
        this.manager=this.manager[0].name;
      },
      (err)=>{

      }
     )
       
      
    });


      },
      (error)=>{
     
      }
    )
  }
     
    
    }
      moveToAssigned() {
          for (let i = this.selectedEmpIndices.length - 1; i >= 0; i--) {
              if (this.selectedEmpIndices[i]) {
                  const selectedEmp = this.unassignedEmpList.splice(i, 1)[0];
                  this.assignedEmpList.push(selectedEmp);
                  this.selectedEmpIndices.splice(i, 1);
                  console.log(selectedEmp);
                  this.movedEmpIds.push(selectedEmp.id);
              }
          }
      }  
      
      moveToUnassigned() {
        for (let i = this.selectedAssignedEmpIndices.length - 1; i >= 0; i--) {
            if (this.selectedAssignedEmpIndices[i]) {
                const selectedEmp = this.assignedEmpList.splice(i, 1)[0];
                this.unassignedEmpList.push(selectedEmp);
                const index = this.movedEmpIds.indexOf(selectedEmp.id);
                if (index !== -1) {
                    // Remove selectedEmp.id from movedEmpIds array
                    this.movedEmpIds.splice(index, 1);
                }
                this.selectedAssignedEmpIndices.splice(i, 1); 
            }
        }
    }

    updateTeam(emp:any){
     }
      save(){
        debugger
        if(this.teamId === 0){
          Swal.fire({
            icon: 'error',
            toast:true,
            title: 'Please select team',
            showConfirmButton: false,
            timer: 1500,
            position: 'top-end'
          });
          return
        }
        else{
          const requestBody={
            teamId:this.teamId,
            userIds: this.movedEmpIds,
          }
          this.commonService
          .putRequest('users/teamId', requestBody).then(
            (resp) => {
              Swal.fire({
                icon: 'success',
                toast:true,
                title: 'Employees added to Team successfully',
                showConfirmButton: false,
                timer: 1500,
                position: 'top-end'
              });
            },
            (error) => {
              console.error('Error:', error);
            }
          )
        }
      }
     }

